import React from 'react';
import {
  Grid,
  Typography,
  Drawer,
  Button,
  IconButton,
  //   Divider,
  Box
} from '@material-ui/core';
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import { textSecondary, white } from 'common/colors';

const DrawerMaintenanceInfo = ({ openDetail, setOpenDetail }) => {
  const infoBox = [
    {
      label: 'Perubahan Bunga',
      value: '1,50% - 2,00%',
      sub: 'Flat per bulan',
      bold: true
    },
    {
      label: 'Bunga Sebelumnya',
      value: '1,50%',
      sub: 'Flat per bulan',
      bold: true
    },
    {
      label: 'Tanggal Berlaku',
      value: 'Desember 2025',
      bold: true
    }
  ];

  const sections = [
    {
      title: 'Apa Artinya untuk Kamu?',
      body: 'Tarif bunga yang kamu terima bisa bervariasi antara 1,50%, 1,60% dan 2,00% per bulan, tergantung hasil dari pengecekan saat pengajuan pinjaman.'
    },
    {
      title:
        'Apakah Perubahan Bunga Berlaku untuk Pinjaman yang Sedang Berjalan?',
      body: 'Tidak. Pinjaman yang sedang berjalan tetap mengikuti perjanjian bunga yang sudah disepakati.'
    },
    {
      title: 'Cara Cek Bunga yang Didapat',
      body: 'Ajukan pinjaman seperti biasa di aplikasi, lalu lihat penawaran bunga yang muncul sebelum kamu melakukan konfirmasi. '
    }
  ];

  const illustration = [
    'Bunga 1,50% /bulan → total bunga ± Rp135.000',
    'Bunga 1,60% /bulan → total bunga ± Rp144.000',
    'Bunga 2,00% /bulan → total bunga ± Rp180.000'
  ];

  const notes = [
    'Berlaku otomatis untuk pengajuan setelah tanggal efektif, sesuai syarat & ketentuan.',
    'Butuh bantuan? Sapa Raya 1500 494 atau pusat bantuan di aplikasi.'
  ];

  return (
    <Drawer
      PaperProps={{
        elevation: 0,
        style: {
          borderTopLeftRadius: '16px',
          borderTopRightRadius: '16px',
          margin: '0 auto',
          maxHeight: 'calc(100% - 24px)',
          maxWidth: '500px',
          minHeight: '18%'
        }
      }}
      anchor="bottom"
      onClose={() => setOpenDetail(false)}
      open={openDetail}
    >
      {/* Header */}
      <Grid
        alignItems="center"
        container
        style={{
          backgroundColor: white,
          borderTopLeftRadius: '16px',
          borderTopRightRadius: '16px',
          position: 'fixed',
          zIndex: 1300,
          padding: '16px',
          maxWidth: '500px'
        }}
      >
        <Typography style={{ flex: 1, fontWeight: 600 }} variant="subtitle1">
          Perubahan Bunga Pinjaman
        </Typography>
        <IconButton
          onClick={() => setOpenDetail(false)}
          style={{ padding: '4px', color: textSecondary }}
        >
          <CloseRoundedIcon />
        </IconButton>
      </Grid>

      {/* Body */}
      <Box style={{ padding: '16px', marginTop: '64px' }}>
        {/* Info box */}
        <Box
          style={{
            borderRadius: '8px',
            backgroundColor: '#F9FAFB',
            padding: '16px',
            marginBottom: '16px',
            border: 1
          }}
        >
          {infoBox.map((item, idx) => (
            <Grid
              alignItems="flex-start"
              container
              justifyContent="space-between"
              key={item.label}
              style={{ marginBottom: idx < infoBox.length - 1 ? '8px' : 0 }}
            >
              {/* Left */}
              <Typography style={{ color: '#6B7280' }} variant="body1">
                {item.label}
              </Typography>

              {/* Right */}
              <Box textAlign="right">
                <Typography
                  color="textPrimary"
                  style={{
                    fontWeight: item.bold ? 600 : 500
                  }}
                  variant="body1"
                >
                  {item.value}
                </Typography>
                {item.sub && (
                  <Typography style={{ color: '#6B7280' }} variant="caption">
                    {item.sub}
                  </Typography>
                )}
              </Box>
            </Grid>
          ))}
        </Box>

        {/* Intro */}
        <Typography
          color="textSecondary"
          style={{ marginBottom: '16px' }}
          variant="body2"
        >
          Perubahan bunga Pinang Flexi dilakukan untuk menyesuaikan profil
          risiko dan riwayat penggunaan tiap pengguna. Tujuannya agar tetap
          kompetitif dan transparan mengikuti pasar, serta tetap patuh pada
          ketentuan dan regulasi yang berlaku.
        </Typography>

        {/* Sections */}
        {sections.map(s => (
          <Box key={s.title} style={{ marginBottom: '16px' }}>
            <Typography
              style={{ fontWeight: 600, marginBottom: '4px' }}
              variant="subtitle2"
            >
              {s.title}
            </Typography>
            <Typography color="textSecondary" variant="body2">
              {s.body}
            </Typography>
          </Box>
        ))}

        {/* Illustration */}
        <Box style={{ marginBottom: '16px' }}>
          <Typography
            style={{ fontWeight: 600, marginBottom: '4px' }}
            variant="subtitle2"
          >
            Contoh Ilustrasi
          </Typography>
          <Typography color="textSecondary" variant="body2">
            Pinjaman Rp3.000.000, tenor 3 bulan:
          </Typography>
          <ul style={{ margin: '8px 0 8px 16px', padding: 0 }}>
            {illustration.map(item => (
              <li key={item}>
                <Typography variant="body2" color="textSecondary">
                  {item}
                </Typography>
              </li>
            ))}
          </ul>
          <Typography
            color="textSecondary"
            style={{ display: 'block', marginTop: '4px' }}
            variant="caption"
          >
            * Catatan: Ilustrasi bersifat perkiraan. Detail final mengikuti
            penawaran di aplikasi.
          </Typography>
        </Box>

        {/* Notes */}
        <Box style={{ marginBottom: '16px' }}>
          <Typography
            style={{ fontWeight: 600, marginBottom: '4px' }}
            variant="subtitle2"
          >
            Catatan Penting
          </Typography>
          <ul style={{ margin: '8px 0 0 16px', padding: 0 }}>
            {notes.map(item => (
              <li key={item}>
                <Typography variant="body2" color="textSecondary">
                  {item}
                </Typography>
              </li>
            ))}
          </ul>
        </Box>

        {/* Action button */}
        <Button
          fullWidth
          onClick={() => setOpenDetail(false)}
          style={{
            borderRadius: '8px',
            backgroundColor: '#F97316',
            color: '#fff',
            fontWeight: 600
          }}
          variant="contained"
        >
          Mengerti
        </Button>
      </Box>
    </Drawer>
  );
};

export default DrawerMaintenanceInfo;
